module.exports = __webpack_public_path__ + "static/williams-grove@2x-162c6754f19f5ab7f1e8e6245164947c.png";